import type { CustomerOrder } from '@eliadmin/core/src/api/customers/customers-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import tinycolor from 'tinycolor2';

export type ProfileOrderStatusProps = {
  order: CustomerOrder;
};
export function ProfileOrderStatus(props: ProfileOrderStatusProps) {
  let statusColor = props.order.status?.color ?? '#000';
  if (!statusColor.startsWith('#')) {
    statusColor = `#${statusColor}`;
  }
  const { t } = useTranslations();

  return (
    <div
      className="whitespace-nowrap text-center text-sm font-bold bg-transparent"
      style={{
        color: tinycolor(statusColor).darken(20).toString(),
      }}
    >
      {props.order.status?.name ?? t('text1102')}
    </div>
  );
}
